import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, TextField, Box, Typography,
  Card, CardActionArea, IconButton, Chip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SmartToyIcon from '@mui/icons-material/SmartToy';

export default function AgentPicker({ open, onClose, agents, onSelect }) {
  const [search, setSearch] = useState('');

  const filtered = agents.filter(
    (a) =>
      a.name.toLowerCase().includes(search.toLowerCase()) ||
      (a.description || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" fontWeight={600}>Kies een Agent</Typography>
        <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          size="small"
          placeholder="Zoek agents..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
          autoFocus
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {/* No agent option */}
          <Card variant="outlined" sx={{ borderColor: 'rgba(45,51,53,0.08)' }}>
            <CardActionArea
              onClick={() => { onSelect(null); onClose(); }}
              sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1.5, justifyContent: 'flex-start' }}
            >
              <SmartToyIcon sx={{ color: '#adb3b5' }} />
              <Box>
                <Typography fontWeight={600} fontSize={14}>Geen agent</Typography>
                <Typography fontSize={12} color="text.secondary">Chat direct met het model</Typography>
              </Box>
            </CardActionArea>
          </Card>
          {filtered.map((agent) => (
            <Card key={agent.id} variant="outlined" sx={{ borderColor: 'rgba(45,51,53,0.08)' }}>
              <CardActionArea
                onClick={() => { onSelect(agent); onClose(); }}
                sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1.5, justifyContent: 'flex-start' }}
              >
                <SmartToyIcon sx={{ color: agent.color || '#526075' }} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography fontWeight={600} fontSize={14}>{agent.name}</Typography>
                    <Chip label={agent.model || 'gpt-5.4'} size="small" sx={{ fontSize: 11, height: 20 }} />
                  </Box>
                  {agent.description && (
                    <Typography fontSize={12} color="text.secondary" noWrap>{agent.description}</Typography>
                  )}
                </Box>
              </CardActionArea>
            </Card>
          ))}
          {filtered.length === 0 && (
            <Typography sx={{ py: 3, textAlign: 'center', color: '#adb3b5', fontSize: 14 }}>
              Geen agents gevonden
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
